import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import {
  RestTicketModel,
  RestTypedTicketAttachment,
  UpdateTypedAttachmentToEntityModel,
} from '@shared/interfaces/turnover.interface';

@Injectable({
  providedIn: 'root',
})
export class TicketsService {
  constructor(private restApiService: RestapiService) {}

  create(turnoverTicket: RestTicketModel): Observable<RestTicketModel> {
    return this.restApiService.create<RestTicketModel>(`Tickets`, turnoverTicket);
  }

  update(turnoverTicket: RestTicketModel): Observable<RestTicketModel> {
    return this.restApiService.update<RestTicketModel>(`Tickets/${turnoverTicket.id}`, turnoverTicket);
  }

  delete(ticketId: number): Observable<RestTicketModel> {
    return this.restApiService.delete<RestTicketModel>(`Tickets/${ticketId}`);
  }

  getTicket(ticketId: number): Observable<RestTicketModel> {
    return this.restApiService.getData<RestTicketModel>(`Tickets/${ticketId}`);
  }

  getTicketAttachment(ticketId: number): Observable<RestTypedTicketAttachment[]> {
    return this.restApiService.getData<RestTypedTicketAttachment[]>(`Tickets/${ticketId}/Attachments`);
  }

  setAttachment(attachmentToEntity: UpdateTypedAttachmentToEntityModel): Observable<RestTypedTicketAttachment> {
    return this.restApiService.create<RestTypedTicketAttachment>(
      `Tickets/${attachmentToEntity.ticketId}/Attachments`,
      attachmentToEntity
    );
  }

  getTicketsByTurnover(turnoverId: number): Observable<RestTicketModel[]> {
    return this.restApiService.getData<RestTicketModel[]>(`Tickets/ByTurnoverId/${turnoverId}`);
  }

  getTicketsByAssigneeId(assigneeId: number): Observable<RestTicketModel[]> {
    return this.restApiService.getData<RestTicketModel[]>(`Tickets/ByAssigneeId/${assigneeId}`);
  }

  getTicketsByPropertyId(propertyId: number): Observable<RestTicketModel[]> {
    return this.restApiService.getData<RestTicketModel[]>(`Tickets/ByPropertyId/${propertyId}`);
  }

  deleteTurnoverAttachment(ticketId: number, attachmentId: number): Observable<boolean> {
    return this.restApiService.delete(`Tickets/${ticketId}/Attachments/${attachmentId}`);
  }
}
